var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FWNElement_observer;
import { LitElement } from 'lit-element';
import { applyFocusVisible } from '@core/accessibility';
import { allowWidgetParam } from '@embed/store/sanitizeWidgetParams';
export class FWNElement extends LitElement {
    constructor() {
        super();
        _FWNElement_observer.set(this, void 0);
        __classPrivateFieldSet(this, _FWNElement_observer, undefined, "f");
        if (this.shadowRoot) {
            applyFocusVisible(this.shadowRoot);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        __classPrivateFieldSet(this, _FWNElement_observer, new MutationObserver((mutations) => {
            if (mutations
                .map((m) => m.attributeName)
                .some((n) => n && allowWidgetParam(n))) {
                this.render();
            }
        }), "f");
        __classPrivateFieldGet(this, _FWNElement_observer, "f").observe(this, { attributes: true });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = __classPrivateFieldGet(this, _FWNElement_observer, "f")) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
}
_FWNElement_observer = new WeakMap();
